import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { BackgroundImage, PrimaryButton } from "../../elements";
import "./style.scss";
import { gtag } from "../../utils";
const WorldwidePresence = props => {
	const { rendering, fields, page } = props;
  const {
  	image,
  	icon,
  	RegionsText,
  	CountriesText,
  	button,
  	pointList,
  	RegionsNum,
  	CountriesNum,
  	leftRightIcon,
  	handIcon,
  	tips
  } = fields;
	const titleNode = useRef();
	const nodeRef = useRef();
	const [listData, setListData] = useState([]);
	const [isShow, setIsShow] = useState(true)

	const onScroll = () => {
		let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
		if (titleNode.current.getBoundingClientRect().top < pageHeight) {
			titleNode.current.setAttribute('animate', 'fadeIn');
		} else {
			titleNode.current.setAttribute('animate', 'fadeOut');
		}

		if (nodeRef.current.getBoundingClientRect().top < pageHeight - 300) {
			let timer = setTimeout((v) => {
				clearTimeout(timer)
				setIsShow(false);
			}, 5000)
		}
	}

	const toggle = (e, item) => {
		gtag('event', 'Component_info', {
			'component_name': 'WorldwidePresence',
			'page_title': page?.name
		});
		let list = JSON.parse(JSON.stringify(pointList));
		list.forEach((el) => {
			if (el.id === item.id) {
				el.show = true;
			} else {
				el.show = false;
			}
		})
		setListData(list)
	}

	const leave = (e, item) => {
		let list = JSON.parse(JSON.stringify(listData));
		list.forEach((el) => {
			if (el.id === item.id) {
				el.show = false;
			}
		})
		setListData(list)
	}

	useEffect(() => {
		let listData = [];
		pointList.forEach((item, index) => {
			let dataItem = {
				fields: item.fields,
				id: item.id,
				show: false
			}
			listData.push(dataItem);
		})
		setListData(listData);
		window.addEventListener("scroll", onScroll);
		return () => {
			window.removeEventListener("scroll", onScroll);
		};
	}, []);
  const rootClasses = classNames("c-worldwide-presence", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} ref={nodeRef}>
    	<div className="c-worldwide-presence__text" ref={titleNode}>
    		<div className="c-worldwide-presence__text__regions">
    			<RichText className="c-worldwide-presence__text__regions__num" tag="div" field={RegionsNum} />
    			<RichText className="c-worldwide-presence__text__regions__text" tag="div" field={RegionsText} />
    		</div>
    		<div className="c-worldwide-presence__text__countries">
    			<RichText className="c-worldwide-presence__text__countries__num" tag="div" field={CountriesNum} />
    			<RichText className="c-worldwide-presence__text__countries__text" tag="div" field={CountriesText} />
    		</div>
    	</div>
    	<div className="c-worldwide-presence__image">
    		<BackgroundImage {...image} className="c-worldwide-presence__image__bg">
    			{listData.map((item, index) => (
    				<div className={"c-worldwide-presence__image__bg__icon"} key={item.id} onMouseOver={(e) => toggle(e, item)} onMouseLeave={(e) => leave(e, item)} onClick={(e) => toggle(e, item)}>
							<BackgroundImage {...icon} className={classNames("c-worldwide-presence__image__bg__icon__image", item.show ? 'active' : '')} />
							<RichText className={classNames("c-worldwide-presence__image__bg__icon__text", item.show ? 'active' : '')} tag="div" field={item?.fields?.text} />
						</div>
					))}
				</BackgroundImage>
			</div>
			{button && <div className="button">
				<PrimaryButton {...button?.fields} />
			</div>}

			{isShow && <div className="hand-animate-content">
				<BackgroundImage {...leftRightIcon} className="left-right-icon" />
				<BackgroundImage {...handIcon} className="hand-icon" />
			</div>}
			{isShow && <RichText tag="div" className="tips" field={tips} />}
		</div>
	);
};

export default WorldwidePresence;